import { Directive, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../util/unsubscribeFromAll';
import { DataGridColumnDefinition } from '../interfaces/data-grid.interface';

@Directive()
export abstract class BaseDataGridCellRenderer implements OnDestroy {
    protected subscriptions: { [key: string]: Subscription } = {};
    public set data(value: unknown[]) {
        this._data = value;
        this.onDataChange();
    }
    get data(): unknown[] {
        return this._data;
    }

    public set column(value: DataGridColumnDefinition) {
        this._column = value;
        this.onDataChange();
    }
    get column(): DataGridColumnDefinition {
        return this._column;
    }

    protected _data!: unknown[];
    protected _column!: DataGridColumnDefinition;

    public constructor() {}

    public ngOnDestroy() {
        unsubscribeFromAll(this.subscriptions);
    }

    public getValueByKeyPath(data: any, key: string | null) {
        if (!data || !key) {
            return undefined;
        }

        return key.split('.').reduce((acc, key) => acc?.[key], data);
    }

    /**
     * Called whenever the this.data or this.column properties change
     * Take care when changing the property as only a reference change will trigger this function
     */
    abstract onDataChange(): any;
}
